function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_273"
}, /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 175,
  x: 0,
  y: 0
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_275"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L236,0 L236,430 L0,430z"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_288"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L236,0 L236,430 L0,430z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-0.0010000000474974513,-47.119998931884766 C20.7189998626709,-47.119998931884766 37.51900100708008,-30.31999969482422 37.51900100708008,-9.600000381469727 C37.51900100708008,-9.600000381469727 37.51900100708008,41.34000015258789 37.51900100708008,41.34000015258789 C37.51900100708008,44.529998779296875 34.92900085449219,47.119998931884766 31.73900032043457,47.119998931884766 C31.73900032043457,47.119998931884766 -31.740999221801758,47.119998931884766 -31.740999221801758,47.119998931884766 C-34.930999755859375,47.119998931884766 -37.520999908447266,44.529998779296875 -37.520999908447266,41.34000015258789 C-37.520999908447266,41.34000015258789 -37.520999908447266,-9.600000381469727 -37.520999908447266,-9.600000381469727 C-37.520999908447266,-30.31999969482422 -20.72100067138672,-47.119998931884766 -0.0010000000474974513,-47.119998931884766z"
}));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "__lottie_element_316"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  clipRule: "nonzero",
  d: " M139,148 C132.1230010986328,148.79800415039062 131.7740020751953,152.74400329589844 126,156 C121.50399780273438,158.53500366210938 115.36100006103516,159.40899658203125 115,166 C114.51399993896484,174.8800048828125 122.95999908447266,177.84300231933594 132,175 C135.031005859375,174.0469970703125 139.16299438476562,170.44200134277344 142,168 C146.11900329589844,164.4550018310547 148.45199584960938,162.34800720214844 149,158 C150.13499450683594,148.99200439453125 142.80799865722656,147.55799865722656 139,148",
  fillOpacity: 1
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4,
  stroke: "rgb(178,50,50)",
  strokeOpacity: 1,
  strokeWidth: 18.9731135503165,
  d: " M19.808000564575195,14.470999717712402 C16.19099998474121,19.39299964904785 10.777999877929688,22.91900062561035 4.535999774932861,24.083999633789062"
});

var _ref8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_321"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L236,0 L236,430 L0,430z"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 236,
  height: 430,
  fill: "#b23232"
});

var _ref10 = /*#__PURE__*/React.createElement("mask", {
  id: "__lottie_element_331"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  clipRule: "nonzero",
  d: " M139,148 C132.1230010986328,148.79800415039062 131.7740020751953,152.74400329589844 126,156 C121.50399780273438,158.53500366210938 115.36100006103516,159.40899658203125 115,166 C114.51399993896484,174.8800048828125 122.95999908447266,177.84300231933594 132,175 C135.031005859375,174.0469970703125 139.16299438476562,170.44200134277344 142,168 C146.11900329589844,164.4550018310547 148.45199584960938,162.34800720214844 149,158 C150.13499450683594,148.99200439453125 142.80799865722656,147.55799865722656 139,148",
  fillOpacity: 1
}));

var _ref11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_334"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L236,0 L236,430 L0,430z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(177,49,49)",
  fillOpacity: 1,
  d: " M-0.5370000004768372,-4.497000217437744 C-0.5370000004768372,-4.497000217437744 1.7730000019073486,-4.2870001792907715 1.7730000019073486,-4.2870001792907715 C5.163000106811523,-3.996999979019165 7.692999839782715,-1.0670000314712524 7.5229997634887695,2.302999973297119 C7.5229997634887695,2.302999973297119 7.502999782562256,2.5329999923706055 7.502999782562256,2.5329999923706055 C7.502999782562256,2.5329999923706055 7.442999839782715,3.572999954223633 7.442999839782715,3.572999954223633 C7.4029998779296875,4.123000144958496 6.933000087738037,4.552999973297119 6.382999897003174,4.513000011444092 C6.263000011444092,4.513000011444092 6.1529998779296875,4.482999801635742 6.043000221252441,4.433000087738037 C5.052999973297119,4.002999782562256 3.703000068664551,3.6730000972747803 1.9830000400543213,3.443000078201294 C-0.34700000286102295,3.132999897003174 -3.0769999027252197,3.4730000495910645 -6.2270002365112305,4.453000068664551 C-6.756999969482422,4.623000144958496 -7.316999912261963,4.322999954223633 -7.4770002365112305,3.7929999828338623 C-7.517000198364258,3.683000087738037 -7.5370001792907715,3.552999973297119 -7.5269999504089355,3.433000087738037 C-7.5269999504089355,3.433000087738037 -7.367000102996826,1.2330000400543213 -7.367000102996826,1.2330000400543213 C-7.066999912261963,-2.2269999980926514 -4.006999969482422,-4.796999931335449 -0.5370000004768372,-4.497000217437744z"
}));

var _ref13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_372"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L236,0 L236,430 L0,430z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-15.645000457763672,-23.636999130249023 C-15.645000457763672,-23.636999130249023 15.645000457763672,-23.636999130249023 15.645000457763672,-23.636999130249023 C28.344999313354492,-23.636999130249023 38.6349983215332,-13.347000122070312 38.6349983215332,-0.6470000147819519 C38.6349983215332,-0.6470000147819519 38.6349983215332,0.652999997138977 38.6349983215332,0.652999997138977 C38.6349983215332,13.343000411987305 28.344999313354492,23.632999420166016 15.645000457763672,23.632999420166016 C15.645000457763672,23.632999420166016 -15.645000457763672,23.632999420166016 -15.645000457763672,23.632999420166016 C-28.344999313354492,23.632999420166016 -38.6349983215332,13.343000411987305 -38.6349983215332,0.652999997138977 C-38.6349983215332,0.652999997138977 -38.6349983215332,-0.6470000147819519 -38.6349983215332,-0.6470000147819519 C-38.6349983215332,-13.347000122070312 -28.344999313354492,-23.636999130249023 -15.645000457763672,-23.636999130249023z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,177,0)",
  fillOpacity: 1,
  d: " M-9.194999694824219,-3.6010000705718994 C-9.194999694824219,-3.6010000705718994 9.194999694824219,-3.6010000705718994 9.194999694824219,-3.6010000705718994 C11.1850004196167,-3.6010000705718994 12.795000076293945,-1.9910000562667847 12.795000076293945,-0.0010000000474974513 C12.795000076293945,1.9889999628067017 11.1850004196167,3.5989999771118164 9.194999694824219,3.5989999771118164 C9.194999694824219,3.5989999771118164 -9.194999694824219,3.5989999771118164 -9.194999694824219,3.5989999771118164 C-11.1850004196167,3.5989999771118164 -12.795000076293945,1.9889999628067017 -12.795000076293945,-0.0010000000474974513 C-12.795000076293945,-1.9910000562667847 -11.1850004196167,-3.6010000705718994 -9.194999694824219,-3.6010000705718994z"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,177,0)",
  fillOpacity: 1,
  d: " M-9.194999694824219,-3.6010000705718994 C-9.194999694824219,-3.6010000705718994 9.194999694824219,-3.6010000705718994 9.194999694824219,-3.6010000705718994 C11.1850004196167,-3.6010000705718994 12.795000076293945,-1.9910000562667847 12.795000076293945,-0.0010000000474974513 C12.795000076293945,1.9889999628067017 11.1850004196167,3.5989999771118164 9.194999694824219,3.5989999771118164 C9.194999694824219,3.5989999771118164 -9.194999694824219,3.5989999771118164 -9.194999694824219,3.5989999771118164 C-11.1850004196167,3.5989999771118164 -12.795000076293945,1.9889999628067017 -12.795000076293945,-0.0010000000474974513 C-12.795000076293945,-1.9910000562667847 -11.1850004196167,-3.6010000705718994 -9.194999694824219,-3.6010000705718994z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M-16.922000885009766,-17.5310001373291 C-13.182000160217285,-21.141000747680664 -7.211999893188477,-21.041000366210938 -3.6019999980926514,-17.291000366210938 C-3.6019999980926514,-17.291000366210938 17.158000946044922,4.198999881744385 17.158000946044922,4.198999881744385 C20.777999877929688,7.948999881744385 20.667999267578125,13.909000396728516 16.92799949645996,17.52899932861328 C13.178000450134277,21.138999938964844 7.2179999351501465,21.038999557495117 3.5980000495910645,17.288999557495117 C3.5980000495910645,17.288999557495117 -17.16200065612793,-4.201000213623047 -17.16200065612793,-4.201000213623047 C-20.77199935913086,-7.940999984741211 -20.672000885009766,-13.91100025177002 -16.922000885009766,-17.5310001373291 C-16.922000885009766,-17.5310001373291 -16.922000885009766,-17.5310001373291 -16.922000885009766,-17.5310001373291z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M16.92799949645996,-17.5310001373291 C20.667999267578125,-13.91100025177002 20.777999877929688,-7.940999984741211 17.158000946044922,-4.201000213623047 C17.158000946044922,-4.201000213623047 -3.6019999980926514,17.288999557495117 -3.6019999980926514,17.288999557495117 C-7.211999893188477,21.038999557495117 -13.182000160217285,21.138999938964844 -16.922000885009766,17.52899932861328 C-20.672000885009766,13.909000396728516 -20.77199935913086,7.948999881744385 -17.16200065612793,4.198999881744385 C-17.16200065612793,4.198999881744385 3.5980000495910645,-17.291000366210938 3.5980000495910645,-17.291000366210938 C7.2179999351501465,-21.041000366210938 13.178000450134277,-21.141000747680664 16.92799949645996,-17.5310001373291 C16.92799949645996,-17.5310001373291 16.92799949645996,-17.5310001373291 16.92799949645996,-17.5310001373291z"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(115,63,7)",
  fillOpacity: 1,
  d: " M-20.231000900268555,-28.04199981689453 C-20.231000900268555,-28.04199981689453 20.229000091552734,-28.04199981689453 20.229000091552734,-28.04199981689453 C22.16900062561035,-28.04199981689453 23.749000549316406,-26.461999893188477 23.749000549316406,-24.52199935913086 C23.749000549316406,-24.52199935913086 23.749000549316406,24.51799964904785 23.749000549316406,24.51799964904785 C23.749000549316406,26.468000411987305 22.16900062561035,28.038000106811523 20.229000091552734,28.038000106811523 C20.229000091552734,28.038000106811523 -20.231000900268555,28.038000106811523 -20.231000900268555,28.038000106811523 C-22.17099952697754,28.038000106811523 -23.750999450683594,26.468000411987305 -23.750999450683594,24.51799964904785 C-23.750999450683594,24.51799964904785 -23.750999450683594,-24.52199935913086 -23.750999450683594,-24.52199935913086 C-23.750999450683594,-26.461999893188477 -22.17099952697754,-28.04199981689453 -20.231000900268555,-28.04199981689453z"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(61,61,61)",
  fillOpacity: 1,
  d: " M28.958999633789062,-0.003000000026077032 C28.958999633789062,12.54699993133545 18.788999557495117,22.716999053955078 6.249000072479248,22.716999053955078 C6.249000072479248,22.716999053955078 -6.250999927520752,22.716999053955078 -6.250999927520752,22.716999053955078 C-18.791000366210938,22.716999053955078 -28.961000442504883,12.54699993133545 -28.961000442504883,-0.003000000026077032 C-28.961000442504883,-12.543000221252441 -18.791000366210938,-22.71299934387207 -6.250999927520752,-22.71299934387207 C-6.250999927520752,-22.71299934387207 6.249000072479248,-22.71299934387207 6.249000072479248,-22.71299934387207 C18.788999557495117,-22.71299934387207 28.958999633789062,-12.543000221252441 28.958999633789062,-0.003000000026077032z"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,2)",
  fillOpacity: 1,
  d: " M-0.0010000000474974513,-47.119998931884766 C20.7189998626709,-47.119998931884766 37.51900100708008,-30.31999969482422 37.51900100708008,-9.600000381469727 C37.51900100708008,-9.600000381469727 37.51900100708008,41.34000015258789 37.51900100708008,41.34000015258789 C37.51900100708008,44.529998779296875 34.92900085449219,47.119998931884766 31.73900032043457,47.119998931884766 C31.73900032043457,47.119998931884766 -31.740999221801758,47.119998931884766 -31.740999221801758,47.119998931884766 C-34.930999755859375,47.119998931884766 -37.520999908447266,44.529998779296875 -37.520999908447266,41.34000015258789 C-37.520999908447266,41.34000015258789 -37.520999908447266,-9.600000381469727 -37.520999908447266,-9.600000381469727 C-37.520999908447266,-30.31999969482422 -20.72100067138672,-47.119998931884766 -0.0010000000474974513,-47.119998931884766z"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-0.0010000000474974513,-47.119998931884766 C8.015999794006348,-47.119998931884766 15.446999549865723,-44.60499954223633 21.54400062561035,-40.31999969482422 C31.204999923706055,-33.53200149536133 20.520000457763672,47.119998931884766 20.520000457763672,47.119998931884766 C20.520000457763672,47.119998931884766 -20.229999542236328,47.119998931884766 -20.229999542236328,47.119998931884766 C-20.229999542236328,47.119998931884766 -29.55699920654297,-36.27199935913086 -17.83300018310547,-42.61800003051758 C-12.529000282287598,-45.48899841308594 -6.454999923706055,-47.119998931884766 -0.0010000000474974513,-47.119998931884766z"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M0,-17.4685001373291 C9.640865325927734,-17.4685001373291 17.4685001373291,-9.640865325927734 17.4685001373291,0 C17.4685001373291,9.640865325927734 9.640865325927734,17.4685001373291 0,17.4685001373291 C-9.640865325927734,17.4685001373291 -17.4685001373291,9.640865325927734 -17.4685001373291,0 C-17.4685001373291,-9.640865325927734 -9.640865325927734,-17.4685001373291 0,-17.4685001373291z"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(115,63,7)",
  fillOpacity: 1,
  d: " M-19.16200065612793,-31.291000366210938 C-19.16200065612793,-31.291000366210938 18.158000946044922,-31.291000366210938 18.158000946044922,-31.291000366210938 C18.158000946044922,-31.291000366210938 18.158000946044922,31.229000091552734 18.158000946044922,31.229000091552734 C18.158000946044922,31.229000091552734 -19.16200065612793,31.229000091552734 -19.16200065612793,31.229000091552734 C-19.16200065612793,31.229000091552734 -19.16200065612793,-31.291000366210938 -19.16200065612793,-31.291000366210938z"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M-22.448999404907227,-50.183998107910156 C-22.448999404907227,-50.183998107910156 22.451000213623047,-50.183998107910156 22.451000213623047,-50.183998107910156 C22.451000213623047,-50.183998107910156 22.451000213623047,50.18600082397461 22.451000213623047,50.18600082397461 C22.451000213623047,50.18600082397461 -22.448999404907227,50.18600082397461 -22.448999404907227,50.18600082397461 C-22.448999404907227,50.18600082397461 -22.448999404907227,-50.183998107910156 -22.448999404907227,-50.183998107910156z"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M-22.909000396728516,-50.183998107910156 C-22.909000396728516,-50.183998107910156 22.910999298095703,-50.183998107910156 22.910999298095703,-50.183998107910156 C22.910999298095703,-50.183998107910156 22.910999298095703,50.18600082397461 22.910999298095703,50.18600082397461 C22.910999298095703,50.18600082397461 -22.909000396728516,50.18600082397461 -22.909000396728516,50.18600082397461 C-22.909000396728516,50.18600082397461 -22.909000396728516,-50.183998107910156 -22.909000396728516,-50.183998107910156z"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M0.004000000189989805,-25.5 C6.794000148773193,-25.5 11.928999900817871,-19.989999771118164 11.928999900817871,-13.1899995803833 C11.928999900817871,-13.1899995803833 11.888999938964844,10.8149995803833 11.888999938964844,10.8149995803833 C11.888999938964844,17.614999771118164 6.754000186920166,23.125 -0.035999998450279236,23.125 C-6.835999965667725,23.125 -12.345999717712402,17.614999771118164 -12.345999717712402,10.8149995803833 C-12.345999717712402,10.8149995803833 -12.305999755859375,-13.1899995803833 -12.305999755859375,-13.1899995803833 C-12.305999755859375,-19.989999771118164 -6.796000003814697,-25.5 0.004000000189989805,-25.5z"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M0,-6.742499828338623 C3.7211856842041016,-6.742499828338623 6.742499828338623,-3.7211856842041016 6.742499828338623,0 C6.742499828338623,3.7211856842041016 3.7211856842041016,6.742499828338623 0,6.742499828338623 C-3.7211856842041016,6.742499828338623 -6.742499828338623,3.7211856842041016 -6.742499828338623,0 C-6.742499828338623,-3.7211856842041016 -3.7211856842041016,-6.742499828338623 0,-6.742499828338623z"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M0,-6.742499828338623 C3.7211856842041016,-6.742499828338623 6.742499828338623,-3.7211856842041016 6.742499828338623,0 C6.742499828338623,3.7211856842041016 3.7211856842041016,6.742499828338623 0,6.742499828338623 C-3.7211856842041016,6.742499828338623 -6.742499828338623,3.7211856842041016 -6.742499828338623,0 C-6.742499828338623,-3.7211856842041016 -3.7211856842041016,-6.742499828338623 0,-6.742499828338623z"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-15.645000457763672,-23.636999130249023 C-15.645000457763672,-23.636999130249023 15.645000457763672,-23.636999130249023 15.645000457763672,-23.636999130249023 C28.344999313354492,-23.636999130249023 38.6349983215332,-13.347000122070312 38.6349983215332,-0.6470000147819519 C38.6349983215332,-0.6470000147819519 38.6349983215332,0.652999997138977 38.6349983215332,0.652999997138977 C38.6349983215332,13.343000411987305 28.344999313354492,23.632999420166016 15.645000457763672,23.632999420166016 C15.645000457763672,23.632999420166016 -15.645000457763672,23.632999420166016 -15.645000457763672,23.632999420166016 C-28.344999313354492,23.632999420166016 -38.6349983215332,13.343000411987305 -38.6349983215332,0.652999997138977 C-38.6349983215332,0.652999997138977 -38.6349983215332,-0.6470000147819519 -38.6349983215332,-0.6470000147819519 C-38.6349983215332,-13.347000122070312 -28.344999313354492,-23.636999130249023 -15.645000457763672,-23.636999130249023z"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,188.77749633789062,83.07550048828125)",
  opacity: 0.6900000000000001
}, /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(195,195,195)",
  fillOpacity: 1,
  d: " M-11.12399959564209,-16.106000900268555 C-11.12399959564209,-16.106000900268555 11.12600040435791,-16.106000900268555 11.12600040435791,-16.106000900268555 C15.685999870300293,-16.106000900268555 19.38599967956543,-12.406000137329102 19.38599967956543,-7.8460001945495605 C19.38599967956543,-7.8460001945495605 19.38599967956543,7.843999862670898 19.38599967956543,7.843999862670898 C19.38599967956543,12.404000282287598 15.685999870300293,16.104000091552734 11.12600040435791,16.104000091552734 C11.12600040435791,16.104000091552734 -11.12399959564209,16.104000091552734 -11.12399959564209,16.104000091552734 C-15.684000015258789,16.104000091552734 -19.384000778198242,12.404000282287598 -19.384000778198242,7.843999862670898 C-19.384000778198242,7.843999862670898 -19.384000778198242,-7.8460001945495605 -19.384000778198242,-7.8460001945495605 C-19.384000778198242,-12.406000137329102 -15.684000015258789,-16.106000900268555 -11.12399959564209,-16.106000900268555z"
})));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M0,-3.2179999351501465 C1.7760142087936401,-3.2179999351501465 3.2179999351501465,-1.7760142087936401 3.2179999351501465,0 C3.2179999351501465,1.7760142087936401 1.7760142087936401,3.2179999351501465 0,3.2179999351501465 C-1.7760142087936401,3.2179999351501465 -3.2179999351501465,1.7760142087936401 -3.2179999351501465,0 C-3.2179999351501465,-1.7760142087936401 -1.7760142087936401,-3.2179999351501465 0,-3.2179999351501465z"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(232,154,94)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(232,154,94)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(61,61,61)",
  fillOpacity: 1,
  d: " M0.0020000000949949026,-5.5980000495910645 C1.9019999504089355,-5.5980000495910645 3.441999912261963,-4.058000087738037 3.441999912261963,-2.1579999923706055 C3.441999912261963,-2.1579999923706055 3.441999912261963,2.1619999408721924 3.441999912261963,2.1619999408721924 C3.441999912261963,4.061999797821045 1.9019999504089355,5.6020002365112305 0.0020000000949949026,5.6020002365112305 C-1.8980000019073486,5.6020002365112305 -3.437999963760376,4.061999797821045 -3.437999963760376,2.1619999408721924 C-3.437999963760376,2.1619999408721924 -3.437999963760376,-2.1579999923706055 -3.437999963760376,-2.1579999923706055 C-3.437999963760376,-4.058000087738037 -1.8980000019073486,-5.5980000495910645 0.0020000000949949026,-5.5980000495910645z"
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(61,61,61)",
  fillOpacity: 1,
  d: " M0.0020000000949949026,-5.5980000495910645 C1.9019999504089355,-5.5980000495910645 3.441999912261963,-4.058000087738037 3.441999912261963,-2.1579999923706055 C3.441999912261963,-2.1579999923706055 3.441999912261963,2.1619999408721924 3.441999912261963,2.1619999408721924 C3.441999912261963,4.061999797821045 1.9019999504089355,5.6020002365112305 0.0020000000949949026,5.6020002365112305 C-1.8980000019073486,5.6020002365112305 -3.437999963760376,4.061999797821045 -3.437999963760376,2.1619999408721924 C-3.437999963760376,2.1619999408721924 -3.437999963760376,-2.1579999923706055 -3.437999963760376,-2.1579999923706055 C-3.437999963760376,-4.058000087738037 -1.8980000019073486,-5.5980000495910645 0.0020000000949949026,-5.5980000495910645z"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(233,155,95)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(233,155,95)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-9.98900032043457 C4.216000080108643,-9.98900032043457 7.636000156402588,-6.568999767303467 7.636000156402588,-2.3589999675750732 C7.636000156402588,-2.3589999675750732 7.636000156402588,2.3510000705718994 7.636000156402588,2.3510000705718994 C7.636000156402588,6.571000099182129 4.216000080108643,9.991000175476074 -0.004000000189989805,9.991000175476074 C-4.214000225067139,9.991000175476074 -7.633999824523926,6.571000099182129 -7.633999824523926,2.3510000705718994 C-7.633999824523926,2.3510000705718994 -7.633999824523926,-2.3589999675750732 -7.633999824523926,-2.3589999675750732 C-7.633999824523926,-6.568999767303467 -4.214000225067139,-9.98900032043457 -0.004000000189989805,-9.98900032043457z"
}));

var _ref41 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(232,154,94)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-4.4629998207092285 C4.216000080108643,-4.4629998207092285 7.636000156402588,-1.0429999828338623 7.636000156402588,3.1670000553131104 C7.636000156402588,3.1670000553131104 7.636000156402588,4.4670000076293945 7.636000156402588,4.4670000076293945 C7.636000156402588,4.4670000076293945 0.16599999368190765,4.4670000076293945 0.16599999368190765,4.4670000076293945 C0.16599999368190765,4.4670000076293945 -7.633999824523926,4.4670000076293945 -7.633999824523926,4.4670000076293945 C-7.633999824523926,4.4670000076293945 -7.633999824523926,3.1670000553131104 -7.633999824523926,3.1670000553131104 C-7.633999824523926,-1.0429999828338623 -4.214000225067139,-4.4629998207092285 -0.004000000189989805,-4.4629998207092285z"
}));

var _ref42 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(232,154,94)",
  fillOpacity: 1,
  d: " M-0.004000000189989805,-4.4629998207092285 C4.216000080108643,-4.4629998207092285 7.636000156402588,-1.0429999828338623 7.636000156402588,3.1670000553131104 C7.636000156402588,3.1670000553131104 7.636000156402588,4.4670000076293945 7.636000156402588,4.4670000076293945 C7.636000156402588,4.4670000076293945 0.35899999737739563,4.4670000076293945 0.35899999737739563,4.4670000076293945 C0.35899999737739563,4.4670000076293945 -7.633999824523926,4.4670000076293945 -7.633999824523926,4.4670000076293945 C-7.633999824523926,4.4670000076293945 -7.633999824523926,3.1670000553131104 -7.633999824523926,3.1670000553131104 C-7.633999824523926,-1.0429999828338623 -4.214000225067139,-4.4629998207092285 -0.004000000189989805,-4.4629998207092285z"
}));

var _ref43 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M4.892000198364258,-2.6050000190734863 C4.081999778747559,-2.6050000190734863 -3.997999906539917,-1.2549999952316284 -7.168000221252441,1.0850000381469727 C-10.338000297546387,3.434999942779541 -0.9610000252723694,8.029999732971191 -0.9610000252723694,8.029999732971191 C-0.9610000252723694,8.029999732971191 7.959000110626221,6.960000038146973 7.959000110626221,6.960000038146973 C7.959000110626221,6.960000038146973 5.711999893188477,-2.6050000190734863 4.892000198364258,-2.6050000190734863z"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-5.110000133514404,-2.6050000190734863 C-4.3460001945495605,-2.6050000190734863 3.2760000228881836,-1.2610000371932983 6.260000228881836,1.0850000381469727 C9.24899959564209,3.434999942779541 0.40799999237060547,8.029999732971191 0.40799999237060547,8.029999732971191 C0.40799999237060547,8.029999732971191 -8.00100040435791,6.960000038146973 -8.00100040435791,6.960000038146973 C-8.00100040435791,6.960000038146973 -5.882999897003174,-2.6050000190734863 -5.110000133514404,-2.6050000190734863z"
}));

var _ref45 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(232,154,94)",
  fillOpacity: 1,
  d: " M0.0020000000949949026,4.5929999351501465 C1.781999945640564,4.5929999351501465 3.2219998836517334,3.1530001163482666 3.2219998836517334,1.3830000162124634 C3.2219998836517334,-0.3970000147819519 0.0020000000949949026,-4.5970001220703125 0.0020000000949949026,-4.5970001220703125 C0.0020000000949949026,-4.5970001220703125 -3.2179999351501465,-0.3970000147819519 -3.2179999351501465,1.3830000162124634 C-3.2179999351501465,3.1530001163482666 -1.777999997138977,4.5929999351501465 0.0020000000949949026,4.5929999351501465z"
}));

var _ref46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4
}));

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4
}));

var _ref48 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(96,52,3)",
  fillOpacity: 1,
  d: " M-0.9760000109672546,-23.368000030517578 C-0.9760000109672546,-23.368000030517578 0.9739999771118164,-23.368000030517578 0.9739999771118164,-23.368000030517578 C0.9739999771118164,-23.368000030517578 0.9739999771118164,23.371999740600586 0.9739999771118164,23.371999740600586 C0.9739999771118164,23.371999740600586 -0.9760000109672546,23.371999740600586 -0.9760000109672546,23.371999740600586 C-0.9760000109672546,23.371999740600586 -0.9760000109672546,-23.368000030517578 -0.9760000109672546,-23.368000030517578z"
}));

var _ref49 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(96,52,3)",
  fillOpacity: 1,
  d: " M4.396999835968018,0.004000000189989805 C4.396999835968018,0.5440000295639038 3.9570000171661377,0.9739999771118164 3.4170000553131104,0.9739999771118164 C3.4170000553131104,0.9739999771118164 -3.4130001068115234,0.9739999771118164 -3.4130001068115234,0.9739999771118164 C-3.953000068664551,0.9739999771118164 -4.39300012588501,0.5440000295639038 -4.39300012588501,0.004000000189989805 C-4.39300012588501,-0.5360000133514404 -3.953000068664551,-0.9760000109672546 -3.4130001068115234,-0.9760000109672546 C-3.4130001068115234,-0.9760000109672546 3.4170000553131104,-0.9760000109672546 3.4170000553131104,-0.9760000109672546 C3.9570000171661377,-0.9760000109672546 4.396999835968018,-0.5360000133514404 4.396999835968018,0.004000000189989805z"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M4.315999984741211,-8.395000457763672 C4.315999984741211,-8.395000457763672 5.105999946594238,-7.934999942779541 5.105999946594238,-7.934999942779541 C9.616000175476074,-5.324999809265137 11.166000366210938,0.4350000023841858 8.555999755859375,4.945000171661377 C5.955999851226807,9.444999694824219 0.19599999487400055,10.994999885559082 -4.314000129699707,8.395000457763672 C-4.314000129699707,8.395000457763672 -5.113999843597412,7.934999942779541 -5.113999843597412,7.934999942779541 C-9.61400032043457,5.324999809265137 -11.163999557495117,-0.4350000023841858 -8.564000129699707,-4.945000171661377 C-5.953999996185303,-9.444999694824219 -0.1940000057220459,-10.994999885559082 4.315999984741211,-8.395000457763672z"
}));

var _ref51 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(179,93,0)",
  fillOpacity: 1,
  d: " M-11.081000328063965,-1.8960000276565552 C-11.081000328063965,-1.8960000276565552 11.079000473022461,-10.357000350952148 11.079000473022461,-10.357000350952148 C11.079000473022461,-10.357000350952148 11.079000473022461,2.753000020980835 11.079000473022461,2.753000020980835 C11.079000473022461,6.333000183105469 8.33899974822998,9.324000358581543 4.769000053405762,9.62399959564209 C4.769000053405762,9.62399959564209 -3.6010000705718994,10.333000183105469 -3.6010000705718994,10.333000183105469 C-7.401000022888184,10.652999877929688 -10.730999946594238,7.834000110626221 -11.060999870300293,4.044000148773193 C-11.071000099182129,3.8440001010894775 -11.081000328063965,3.6540000438690186 -11.081000328063965,3.4639999866485596 C-11.081000328063965,3.4639999866485596 -11.081000328063965,-1.8960000276565552 -11.081000328063965,-1.8960000276565552z"
}));

var _ref52 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M0.07599999755620956,-4.015999794006348 C0.07599999755620956,-4.015999794006348 3.7960000038146973,-1.315999984741211 3.7960000038146973,-1.315999984741211 C5.265999794006348,-0.2460000067949295 5.5960001945495605,1.8140000104904175 4.526000022888184,3.2839999198913574 C3.4560000896453857,4.763999938964844 1.3960000276565552,5.084000110626221 -0.07400000095367432,4.013999938964844 C-0.07400000095367432,4.013999938964844 -3.7939999103546143,1.3140000104904175 -3.7939999103546143,1.3140000104904175 C-5.263999938964844,0.24400000274181366 -5.593999862670898,-1.815999984741211 -4.52400016784668,-3.2860000133514404 C-3.4539999961853027,-4.75600004196167 -1.3940000534057617,-5.085999965667725 0.07599999755620956,-4.015999794006348 C0.07599999755620956,-4.015999794006348 0.07599999755620956,-4.015999794006348 0.07599999755620956,-4.015999794006348z"
}));

var _ref53 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-5.113999843597412,-7.934999942779541 C-5.113999843597412,-7.934999942779541 -4.314000129699707,-8.395000457763672 -4.314000129699707,-8.395000457763672 C0.19599999487400055,-10.994999885559082 5.955999851226807,-9.444999694824219 8.555999755859375,-4.945000171661377 C11.166000366210938,-0.4350000023841858 9.616000175476074,5.324999809265137 5.105999946594238,7.934999942779541 C5.105999946594238,7.934999942779541 4.315999984741211,8.395000457763672 4.315999984741211,8.395000457763672 C-0.1940000057220459,10.994999885559082 -5.953999996185303,9.444999694824219 -8.564000129699707,4.945000171661377 C-11.163999557495117,0.4350000023841858 -9.61400032043457,-5.324999809265137 -5.113999843597412,-7.934999942779541z"
}));

var _ref54 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(179,93,0)",
  fillOpacity: 1,
  d: " M-11.081000328063965,-10.340999603271484 C-11.081000328063965,-10.340999603271484 11.079000473022461,-1.88100004196167 11.079000473022461,-1.88100004196167 C11.079000473022461,-1.88100004196167 11.079000473022461,3.4489998817443848 11.079000473022461,3.4489998817443848 C11.079000473022461,7.249000072479248 7.999000072479248,10.33899974822998 4.189000129699707,10.33899974822998 C3.999000072479248,10.33899974822998 3.809000015258789,10.329000473022461 3.61899995803833,10.319000244140625 C3.61899995803833,10.319000244140625 -4.750999927520752,9.628999710083008 -4.750999927520752,9.628999710083008 C-8.331000328063965,9.329000473022461 -11.081000328063965,6.339000225067139 -11.081000328063965,2.759000062942505 C-11.081000328063965,2.759000062942505 -11.081000328063965,-10.340999603271484 -11.081000328063965,-10.340999603271484z"
}));

var _ref55 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M-10.14799976348877,-10.746999740600586 C-6.3480000495910645,-14.29699993133545 -0.3779999911785126,-14.086999893188477 3.171999931335449,-10.277000427246094 C3.171999931335449,-10.277000427246094 13.152000427246094,0.4230000078678131 13.152000427246094,0.4230000078678131 C13.152000427246094,0.4230000078678131 -0.6380000114440918,13.27299976348877 -0.6380000114440918,13.27299976348877 C-0.6380000114440918,13.27299976348877 -10.618000030517578,2.572999954223633 -10.618000030517578,2.572999954223633 C-14.168000221252441,-1.2369999885559082 -13.958000183105469,-7.197000026702881 -10.14799976348877,-10.746999740600586z"
}));

var _ref56 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M0.6320000290870667,13.27299976348877 C0.6320000290870667,13.27299976348877 -13.14799976348877,0.4230000078678131 -13.14799976348877,0.4230000078678131 C-13.14799976348877,0.4230000078678131 -3.1679999828338623,-10.277000427246094 -3.1679999828338623,-10.277000427246094 C0.38199999928474426,-14.086999893188477 6.3420000076293945,-14.29699993133545 10.152000427246094,-10.746999740600586 C13.961999893188477,-7.197000026702881 14.161999702453613,-1.2369999885559082 10.612000465393066,2.572999954223633 C10.612000465393066,2.572999954223633 0.6320000290870667,13.27299976348877 0.6320000290870667,13.27299976348877z"
}));

var _ref57 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-3.7939999103546143,-1.315999984741211 C-3.7939999103546143,-1.315999984741211 -0.07400000095367432,-4.015999794006348 -0.07400000095367432,-4.015999794006348 C1.3960000276565552,-5.085999965667725 3.4560000896453857,-4.75600004196167 4.526000022888184,-3.2860000133514404 C5.5960001945495605,-1.815999984741211 5.265999794006348,0.24400000274181366 3.7960000038146973,1.3140000104904175 C3.7960000038146973,1.3140000104904175 0.07599999755620956,4.013999938964844 0.07599999755620956,4.013999938964844 C-1.3940000534057617,5.084000110626221 -3.4539999961853027,4.763999938964844 -4.52400016784668,3.2839999198913574 C-5.593999862670898,1.8140000104904175 -5.263999938964844,-0.2460000067949295 -3.7939999103546143,-1.315999984741211z"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(61,61,61)",
  fillOpacity: 1,
  d: " M16.854000091552734,-1.6399999856948853 C16.854000091552734,-1.6399999856948853 16.854000091552734,1.6399999856948853 16.854000091552734,1.6399999856948853 C16.854000091552734,10.949999809265137 9.303999900817871,18.5 0.004000000189989805,18.5 C-9.305999755859375,18.5 -16.856000900268555,10.949999809265137 -16.856000900268555,1.6399999856948853 C-16.856000900268555,1.6399999856948853 -16.856000900268555,-1.6399999856948853 -16.856000900268555,-1.6399999856948853 C-16.856000900268555,-10.949999809265137 -9.305999755859375,-18.5 0.004000000189989805,-18.5 C9.303999900817871,-18.5 16.854000091552734,-10.949999809265137 16.854000091552734,-1.6399999856948853z"
}));

var _ref59 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(177,49,49)",
  fillOpacity: 1,
  d: " M-0.5370000004768372,-4.497000217437744 C-0.5370000004768372,-4.497000217437744 1.7730000019073486,-4.2870001792907715 1.7730000019073486,-4.2870001792907715 C5.163000106811523,-3.996999979019165 7.692999839782715,-1.0670000314712524 7.5229997634887695,2.302999973297119 C7.5229997634887695,2.302999973297119 7.502999782562256,2.5329999923706055 7.502999782562256,2.5329999923706055 C7.502999782562256,2.5329999923706055 7.442999839782715,3.572999954223633 7.442999839782715,3.572999954223633 C7.4029998779296875,4.123000144958496 6.933000087738037,4.552999973297119 6.382999897003174,4.513000011444092 C6.263000011444092,4.513000011444092 6.1529998779296875,4.482999801635742 6.043000221252441,4.433000087738037 C5.052999973297119,4.002999782562256 3.703000068664551,3.6730000972747803 1.9830000400543213,3.443000078201294 C-0.34700000286102295,3.132999897003174 -3.0769999027252197,3.4730000495910645 -6.2270002365112305,4.453000068664551 C-6.756999969482422,4.623000144958496 -7.316999912261963,4.322999954223633 -7.4770002365112305,3.7929999828338623 C-7.517000198364258,3.683000087738037 -7.5370001792907715,3.552999973297119 -7.5269999504089355,3.433000087738037 C-7.5269999504089355,3.433000087738037 -7.367000102996826,1.2330000400543213 -7.367000102996826,1.2330000400543213 C-7.066999912261963,-2.2269999980926514 -4.006999969482422,-4.796999931335449 -0.5370000004768372,-4.497000217437744z"
}));

var _ref60 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-5.563000202178955,-3.4059998989105225 C-5.563000202178955,-3.4059998989105225 5.436999797821045,-3.5959999561309814 5.436999797821045,-3.5959999561309814 C5.986999988555908,-3.6059999465942383 6.447000026702881,-3.1659998893737793 6.456999778747559,-2.615999937057495 C6.456999778747559,-2.615999937057495 6.546999931335449,2.384000062942505 6.546999931335449,2.384000062942505 C6.557000160217285,2.934000015258789 6.117000102996826,3.3940000534057617 5.557000160217285,3.4040000438690186 C5.557000160217285,3.4040000438690186 -5.442999839782715,3.5940001010894775 -5.442999839782715,3.5940001010894775 C-5.993000030517578,3.6040000915527344 -6.442999839782715,3.1640000343322754 -6.453000068664551,2.614000082015991 C-6.453000068664551,2.614000082015991 -6.543000221252441,-2.385999917984009 -6.543000221252441,-2.385999917984009 C-6.552999973297119,-2.936000108718872 -6.11299991607666,-3.3959999084472656 -5.563000202178955,-3.4059998989105225z"
}));

var _ref61 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(240,75,75)",
  fillOpacity: 1,
  d: " M0.49000000953674316,-6.980000019073486 C4.349999904632568,-6.710000038146973 7.25,-3.369999885559082 6.980000019073486,0.49000000953674316 C6.710000038146973,4.349999904632568 3.369999885559082,7.25 -0.49000000953674316,6.980000019073486 C-4.340000152587891,6.710000038146973 -7.25,3.369999885559082 -6.980000019073486,-0.49000000953674316 C-6.710000038146973,-4.340000152587891 -3.369999885559082,-7.25 0.49000000953674316,-6.980000019073486z"
}));

var _ref62 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M5.718999862670898,-7.591000080108643 C9.909000396728516,-4.431000232696533 10.74899959564209,1.5290000438690186 7.589000225067139,5.718999862670898 C4.428999900817871,9.909000396728516 -1.531000018119812,10.74899959564209 -5.7210001945495605,7.589000225067139 C-9.91100025177002,4.428999900817871 -10.741000175476074,-1.531000018119812 -7.591000080108643,-5.7210001945495605 C-4.431000232696533,-9.91100025177002 1.5290000438690186,-10.741000175476074 5.718999862670898,-7.591000080108643z"
}));

var _ref63 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,202,163)",
  fillOpacity: 1,
  d: " M-0.6980000138282776,-9.104000091552734 C5.751999855041504,-5.173999786376953 7.6620001792907715,0.8059999942779541 4.572000026702881,7.565999984741211 C3.7720000743865967,9.326000213623047 1.6920000314712524,10.095999717712402 -0.06800000369548798,9.295999526977539 C-1.8179999589920044,8.496000289916992 -2.5980000495910645,6.415999889373779 -1.7979999780654907,4.656000137329102 C-0.1979999989271164,1.156000018119812 -0.8880000114440918,-1.0240000486373901 -4.3379998207092285,-3.124000072479248 C-5.98799991607666,-4.133999824523926 -6.507999897003174,-6.283999919891357 -5.507999897003174,-7.934000015258789 C-4.498000144958496,-9.583999633789062 -2.3480000495910645,-10.104000091552734 -0.6980000138282776,-9.104000091552734z"
}));

var _ref64 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(200,105,1)",
  fillOpacity: 1,
  d: " M-9.423999786376953,-9.008953094482422 C-9.423999786376953,-9.008953094482422 9.425999641418457,-9.008953094482422 9.425999641418457,-9.008953094482422 C9.425999641418457,-9.008953094482422 9.425999641418457,9.579999923706055 9.425999641418457,9.579999923706055 C9.425999641418457,14.779999732971191 5.205999851226807,19 -0.004000000189989805,19 C-5.203999996185303,19 -9.423999786376953,14.779999732971191 -9.423999786376953,9.579999923706055 C-9.423999786376953,9.579999923706055 -9.423999786376953,-9.008953094482422 -9.423999786376953,-9.008953094482422z"
}));

var _ref65 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4,
  stroke: "rgb(233,155,95)",
  strokeOpacity: 1,
  strokeWidth: 3.5,
  d: " M-17.322999954223633,-9.996000289916992 C-13.86299991607666,-15.973999977111816 -7.3979997634887695,-20 0,-20 C0,-20 0,-20 0,-20 C1.4240000247955322,-20 2.813999891281128,-19.85099983215332 4.15500020980835,-19.566999435424805"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  width: 236,
  height: 430,
  fill: "#b23232"
});

var _ref68 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(240,76,76)",
  fillOpacity: 1,
  d: " M0.0020000000949949026,8.371999740600586 C4.622000217437744,8.371999740600586 8.371999740600586,4.622000217437744 8.371999740600586,0.0020000000949949026 C8.371999740600586,-4.618000030517578 4.622000217437744,-8.368000030517578 0.0020000000949949026,-8.368000030517578 C-4.618000030517578,-8.368000030517578 -8.368000030517578,-4.618000030517578 -8.368000030517578,0.0020000000949949026 C-8.368000030517578,4.622000217437744 -4.618000030517578,8.371999740600586 0.0020000000949949026,8.371999740600586z"
}));

var _ref69 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-8.96399974822998,-2.7890000343322754 C-8.96399974822998,-2.7890000343322754 6.515999794006348,-2.7890000343322754 6.515999794006348,-2.7890000343322754 C7.866000175476074,-2.7890000343322754 8.965999603271484,-1.6890000104904175 8.965999603271484,-0.33899998664855957 C8.965999603271484,-0.33899998664855957 8.965999603271484,0.3409999907016754 8.965999603271484,0.3409999907016754 C8.965999603271484,1.690999984741211 7.866000175476074,2.7909998893737793 6.515999794006348,2.7909998893737793 C6.515999794006348,2.7909998893737793 -6.513999938964844,2.7909998893737793 -6.513999938964844,2.7909998893737793 C-7.863999843597412,2.7909998893737793 -8.96399974822998,1.690999984741211 -8.96399974822998,0.3409999907016754 C-8.96399974822998,0.3409999907016754 -8.96399974822998,-2.7890000343322754 -8.96399974822998,-2.7890000343322754z"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(240,76,76)",
  fillOpacity: 1,
  d: " M0.0020000000949949026,8.371999740600586 C4.622000217437744,8.371999740600586 8.371999740600586,4.622000217437744 8.371999740600586,0.0020000000949949026 C8.371999740600586,-4.618000030517578 4.622000217437744,-8.368000030517578 0.0020000000949949026,-8.368000030517578 C-4.618000030517578,-8.368000030517578 -8.368000030517578,-4.618000030517578 -8.368000030517578,0.0020000000949949026 C-8.368000030517578,4.622000217437744 -4.618000030517578,8.371999740600586 0.0020000000949949026,8.371999740600586z"
}));

var _ref71 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(2,0,0,2,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M-8.96399974822998,-2.7890000343322754 C-8.96399974822998,-2.7890000343322754 6.515999794006348,-2.7890000343322754 6.515999794006348,-2.7890000343322754 C7.866000175476074,-2.7890000343322754 8.965999603271484,-1.6890000104904175 8.965999603271484,-0.33899998664855957 C8.965999603271484,-0.33899998664855957 8.965999603271484,0.3409999907016754 8.965999603271484,0.3409999907016754 C8.965999603271484,1.690999984741211 7.866000175476074,2.7909998893737793 6.515999794006348,2.7909998893737793 C6.515999794006348,2.7909998893737793 -6.513999938964844,2.7909998893737793 -6.513999938964844,2.7909998893737793 C-7.863999843597412,2.7909998893737793 -8.96399974822998,1.690999984741211 -8.96399974822998,0.3409999907016754 C-8.96399974822998,0.3409999907016754 -8.96399974822998,-2.7890000343322754 -8.96399974822998,-2.7890000343322754z"
}));

var SvgPerson10 = function SvgPerson10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118 175",
    width: 118,
    height: 175,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_306",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.96150207519531,293.780517578125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref5)), _ref6, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_314",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.00050354003906,143.76898193359375)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref7)), _ref8, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_330",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_331)",
    transform: "matrix(1,0,0,1,0.00049591064453125,0.00048828125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref9)), _ref10, _ref11, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_365",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5908307433128357,-0.1517224907875061,0.07461781799793243,0.29057323932647705,141.77841186523438,165.93731689453125)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref12)), _ref13, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_463",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,116.90650177001953,136.8074951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref14))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_273)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_275)",
    transform: "matrix(0.5,0,0,0.5,0.5,-1)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,88.09300231933594,421.8840026855469)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref15), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,147.85400390625,421.8840026855469)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref16), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,178.11550903320312,256.7135009765625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref17), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,56.11649703979492,256.7135009765625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref18), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.69750213623047,353.38848876953125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref19), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,91.46649169921875,91.427001953125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref20), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,116.96150207519531,293.780517578125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref21), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_306)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_288)",
    transform: "matrix(1,0,0,1,0.0005035400390625,2.00048828125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.96099853515625,291.7799987792969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref22), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,124.44100189208984,199.072998046875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref23), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.78900146484375,327.177001953125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref24), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,185.88800048828125,291.7799987792969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref25), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,45.832000732421875,291.7799987792969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref26))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,116.86650085449219,183.73751831054688)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref27), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,196.17449951171875,134.968994140625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref28), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,35.35900115966797,134.968994140625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref29), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,116.90650177001953,136.8074951171875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref30), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_463)",
    style: {
      display: "block"
    }
  }, _ref31), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.89099884033203,149.281005859375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref32), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.11349487304688,119.77450561523438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref33), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.11349487304688,119.77450561523438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref34), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.11349487304688,125.29751586914062)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref35), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.11349487304688,125.2974853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref36), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,102.3905029296875,125.55349731445312)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref37), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,130.9654998779297,125.323486328125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref38), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.11349487304688,125.72824096679688)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref39), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.11349487304688,125.72824096679688)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref40), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.11349487304688,113.0784912109375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref41), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.11349487304688,113.0784912109375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref42), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,140.2534942626953,140.88250732421875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref43), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9866352677345276,-0.16294434666633606,0.16294434666633606,0.9866352677345276,102.80223083496094,156.1053466796875)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref44), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,116.0155029296875,142.57150268554688)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref45), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _ref46, _ref47), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.7864990234375,362.73651123046875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref48), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,117.7864990234375,315.9525146484375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref49), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,59.37949752807617,303.7445068359375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref50), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,65.0094985961914,318.5735168457031)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref51), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,74.54350280761719,299.6715087890625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref52), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,175.73353576660156,303.8114929199219)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref53), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,170.10350036621094,318.54150390625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref54), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,43.001502990722656,286.7095031738281)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref55), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,192.11154174804688,286.70947265625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref56), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,160.56854248046875,299.6724853515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref57), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999289512634277,0.011920157819986343,-0.011920157819986343,0.9999289512634277,66.59375,94.3330078125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref58), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5908307433128357,-0.1517224907875061,0.07461781799793243,0.29057323932647705,141.77841186523438,165.93731689453125)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref59), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_365)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_372)",
    transform: "matrix(0.9816271662712097,0.19080892205238342,-0.19080892205238342,0.9816271662712097,31.945419311523438,-17.532806396484375)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,109.01499938964844,157.2270050048828)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref60), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,113.43099975585938,185.8769989013672)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref61))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.4121817648410797,-0.9111016392707825,0.9111016392707825,-0.4121817648410797,166.5271759033203,235.5797119140625)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref62), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.6986703872680664,-0.7154436707496643,0.7154436707496643,-0.6986703872680664,152.27117919921875,234.80848693847656)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref63), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6210926175117493,-0.7837371826171875,0.7837371826171875,0.6210926175117493,189.8651885986328,255.00083923339844)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref64), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998566746711731,0.0535210445523262,-0.0535210445523262,0.998566746711731,143.12550354003906,174.06436157226562)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref65), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _ref66), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_316)",
    transform: "matrix(1,0,0,1,0.00049591064453125,0.00048828125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref67), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_330)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_334)",
    transform: "matrix(1,0,0,1,-2.093505859375,2.000518798828125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,121.68199920654297,180.03700256347656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref68), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.08799743652344,150.35800170898438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref69))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_314)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_321)",
    transform: "matrix(1,0,0,1,-2.093505859375,2.000518798828125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,121.68199920654297,180.03700256347656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref70), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,134.08799743652344,150.35800170898438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref71))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person10.e8abd7bb.svg";
export { ForwardRef as ReactComponent };